import { Component } from '@angular/core';
import { MobileMenuService } from '../../../../shared/services/mobile-menu.service';
import { WishlistService } from '../../../../shared/services/wishlist.service';
import { CartService } from '../../../../shared/services/cart.service';

import { ApiService } from '@app/shared/services/api.service';
import { Product } from '../../../../shared/interfaces/product';
import { RequestModel } from '../../../../shared/interfaces/RequestModel';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule, FormGroup, FormControl, ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { StoreService } from '../../../../shared/services/store.service';
import { environment } from '@environments/environment';
import { RootService } from '@app/shared/services/root.service';
import { CompareService } from '@app/shared/services/compare.service';

@Component({
    selector: 'app-mobile-header',
    templateUrl: './mobile-header.component.html',
    styleUrls: ['./mobile-header.component.scss']
})
export class MobileHeaderComponent {
    logoUrl = 'assets/images/logos/';
    searchForm: FormGroup;
    keyword = '';

    constructor(
        public root: RootService,
        public menu: MobileMenuService,
        public wishlist: WishlistService,
        public cart: CartService,
        private apiServices: ApiService,
        private route: ActivatedRoute,
        private router: Router,
        public store: StoreService,
        private formBuilder: FormBuilder,
        public compare: CompareService
    ) {
        this.logoUrl += environment.project + '/logo_' + localStorage.getItem('lan').toLowerCase() + '.png';
        this.searchForm = this.formBuilder.group({ keyword: ['', Validators.required] });

    }

    onSubmit(e) {
        console.log('search keyword : ', this.keyword);
        this.router.navigate(['/shop/search/', this.keyword]);
    }

    handleKeyUp(e) {
        if (e.keyCode === 13) {
            this.onSubmit(e);
        }
    }


}
